import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardStepper } from "./DashboardStepper";
import { DealsChart } from "./DealsChart";
import { HotContacts } from "./HotContacts";
import { RecentTierChanges } from "./RecentTierChanges";
import { ScoreDistribution } from "./ScoreDistribution";
import { TasksList } from "./TasksList";
import { Welcome } from "./Welcome";
import { MyTasksBoard } from "../tasks/MyTasksBoard";
import { UnassignedQueue } from "../contacts/UnassignedQueue";

export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contact_notes", {
      pagination: { page: 1, perPage: 1 },
    });

  const { total: totalDeal, isPending: isPendingDeal } = useGetList<Contact>(
    "deals",
    {
      pagination: { page: 1, perPage: 1 },
    },
  );

  const isPending = isPendingContact || isPendingContactNotes || isPendingDeal;

  if (isPending) {
    return null;
  }

  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  if (!totalContactNotes) {
    return <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />;
  }

  return (
    <div className="flex flex-col gap-6 mt-1">
      {/* Top: My Tasks Kanban */}
      <div>
        <MyTasksBoard />
      </div>

      {/* Deals Chart — full width */}
      {totalDeal ? <DealsChart /> : null}

      {/* Middle row: Score Distribution + Recent Tier Changes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ScoreDistribution />
        <RecentTierChanges />
      </div>

      {/* Unassigned Contacts Queue */}
      <UnassignedQueue />

      {/* Bottom: existing dashboard content */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-3">
          <div className="flex flex-col gap-4">
            {import.meta.env.VITE_IS_DEMO === "true" ? <Welcome /> : null}
            <HotContacts />
          </div>
        </div>
        <div className="md:col-span-6">
          <DashboardActivityLog />
        </div>
        <div className="md:col-span-3">
          <TasksList />
        </div>
      </div>
    </div>
  );
};
